import moment from "moment";

export const convertDateFormat = (dateStr: string): string => {
    if (!dateStr) return dateStr;
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
};

export const getInterval = (from: string, to: string) => {
    const fromFormatted = convertDateFormat(from);
    const toFormatted = convertDateFormat(to);

    return moment(toFormatted, 'DD/MM/YYYY').diff(
        moment(fromFormatted, 'DD/MM/YYYY'),
        'days'
    )
};
